import $ from "jquery";

$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function updateTabCount() {
    var count = $('li.check').length;
    $('#tabs-count').html(count);
}

var $collection = $('h2[id]');
if ($collection.length > 0) {
    $collection.each(function () {
        var $item = $(this);
        var id = $item.attr('id');

        var link = $('a[href="#' + id + '"]');
        $(link).click(function () {
            $('html, body').animate({
                scrollTop: $item.offset().top - 100
            }, 50);
        });

        $(document).on('scroll', function () {
            var id = $item.attr('id');
            var $li = $('a[href="#' + id + '"]').parent().parent();

            if ($item.isInViewport() || $(this).scrollTop() >= $($item).position().top) {
                if (!$li.hasClass('check')) {
                    $li.addClass('check');
                    updateTabCount();
                }
            } else {
                $li.removeClass('check');
                updateTabCount();
            }

            if ($(window).scrollTop() === 0) {
                $li.removeClass('check');
            }

            if ($item.isInViewport()) {
                if (id.match(/:/gm) != null) {
                    var string1 = id.split(':')[0];
                    var string2 = 'tab_' + id.split(':')[1];

                    $('#carouselNavigation .carousel-item').each(function () {
                        var carId = $(this).attr('id');

                        if (string1 === carId || string2 === carId) {
                            $(this).addClass('active');
                        } else {
                            $(this).removeClass('active');

                            if ($('#carouselNavigation .carousel-item.active').length < 1) {
                                $('#carouselNavigation .carousel-item').last().addClass('active');
                            } else if ($('#carouselNavigation .carousel-item.active').length > 1){
                                $('#carouselNavigation .carousel-item').last().removeClass('active');
                            }
                        }
                    });
                } else {
                    $('#carouselNavigation .carousel-item').each(function () {
                        var carId = $(this).attr('id');

                        if (id === carId) {
                            $(this).addClass('active');
                        } else {
                            $(this).removeClass('active');

                            if ($('#carouselNavigation .carousel-item.active').length < 1) {
                                $('#carouselNavigation .carousel-item').last().addClass('active');
                            }  else if ($('#carouselNavigation .carousel-item.active').length > 1){
                                $('#carouselNavigation .carousel-item').last().removeClass('active');
                            }
                        }
                    });
                }
            }
        })
    });
}